import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { of } from 'rxjs/observable/of'
import { catchError, debounceTime, exhaustMap, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators'
import { environment } from '../../../../../environments/environment'


import { AppState } from '../../../../store'
import * as fromTeam from '../selectors/team.selectors'
import * as fromUsers from '../selectors/users.selectors'
import * as App from '../../../../store/actions/app.actions'
import * as Users from '../actions/users.actions'
import * as Members from '../../../team/store/actions/members.actions'

import { cacheFirst } from '../../../utils/helpers'
import { JeanService } from '../../../../api/api/services/jean.service'
import { VendorUserV1 } from '../../../../api/api/models/vendor-user-v1'
import { VendorUsersV1 } from '../../../../api/api/models/vendor-users-v1'
import { ChangePasswordModel } from '../../../../api/identity/models/change-password-model'
import { UserV2Service } from '../../../../api/identity/services/user-v2.service'
import { VendorTeamV1 } from '../../../../api/api/models/vendor-team-v1'
import { RegistrationModel } from '../../../../api/identity/models/registration-model'

@Injectable()
export class UsersEffects {

  constructor(private actions$: Actions,
              private store: Store<AppState>,
              private jeanService: JeanService,
              private authService: UserV2Service) {
  }

  @Effect()
  updateUser$ = this.actions$.pipe(
    ofType(Users.UPDATE_USER),
    debounceTime(environment.debounceTime),
    map((action: Users.UpdateUser) => action.payload.user),
    switchMap((user: VendorUserV1) =>
      this.jeanService
        .UpdateVendorUser({
          model: {
            name: user.name,
            email: user.email,
            position: user.position,
          },
          vendorUserId: user.id,
          version: '1',
        }).pipe(
          mergeMap(_ => [
            new App.ApiCallSuccess({
              title: 'Updated',
              msg: 'User was updated'
            }),
            new Users.UpdateUserSuccess({user})
          ]),
          catchError(error => of(new App.ApiCallFailure({
            title: 'Error',
            msg: 'Could not update user'
        }))))
    ))

  @Effect()
  loadUsers$ = cacheFirst({
    store: this.store,
    actions$: this.actions$,
    type: Users.LOAD_USERS,
    selector: fromUsers.getUsersSelector
  }).pipe(
    exhaustMap(_ =>
      this.jeanService
        .GetVendorUsers({version: '1', limit: 0}).pipe(
        map((users: VendorUsersV1) => new Users.LoadUsersSuccess({users: users.items})),
        catchError(error => of(new App.ApiCallFailure({
          title: 'Error',
          msg: 'Could not load users'
        }))))
    ))

  /**
   * Create user and add him to team:
   * 1) register user -> void
   * 2) assign registered user.email to vendors -> VendorUser
   * 3) add assigned vendorUserId to team
   * @type {Observable<any>}
   */
  @Effect()
  createUser$ = this.actions$.pipe(
    ofType(Users.CREATE_USER),
    map(_ => new App.ApiCallInfo({
      title: 'Nothing',
      msg: 'Not implemented yet'
    })))
    // map((action: Users.CreateUser) => action.payload), // FIXME when API done
    // withLatestFrom(this.store.select(fromTeam.getEditingTeamSelector)),
    // exhaustMap(([registrationModel, team]: [RegistrationModel, VendorTeamV1]) =>
    //   this.authService
    //     .registration({
    //       model: registrationModel,
    //       // country: 'cz', // TODO when idsrv done
    //       version: '2',
    //     }).pipe(
    //       mergeMap(_ => [
    //         new App.ApiCallSuccess({
    //           title: 'Created',
    //           msg: 'User was created'
    //         }),
    //         new Users.LoadCreatedUser({email: registrationModel.email, vendorTeamId: team.id}),
    //       ]),
    //       catchError(error => of(new App.ApiCallFailure({
    //         title: 'Error',
    //         msg: 'Could not create user'
    //     }))))
    // ))

  // @Effect()
  // loadCreatedUser$ = this.actions$.pipe(
  //   ofType(Users.LOAD_CREATED_USER),
  //   map((action: Users.LoadCreatedUser) => action.payload),
  //   exhaustMap(({email, vendorTeamId}) =>
  //     this.jeanService
  //       .vendorUserCreate({model: {email}, country: 'cz', version: '1'}).pipe( // FIXME when API done
  //         mergeMap((user: VendorUserV1) => [
  //           new Users.LoadCreatedUserSuccess({user}),
  //           new Members.AddTeamMember({vendorUserId: user.id, vendorTeamId}),
  //         ]),
  //         catchError(error => of(new App.ApiCallFailure({
  //           title: 'Error',
  //           msg: 'Could not load created user'
  //         }))))
  //   ))
}



// WEBPACK FOOTER //
// ./src/app/shared/team/store/effects/users.effects.ts